import { SearchTerm } from "./SearchTerm";

const AccessGroupOssDeviceSearch: SearchTerm[] = [
    {
        heading: "Name",
        accessor: "name",
        searchOnName: "ossDevice.ossdName",
        translationKey: "name"
    },
    {
        heading: "Unique Identifier",
        accessor: "ossdDeviceId",
        searchOnName: "ossDevice.ossdDeviceId",
        translationKey: "uniqueIdentifier"
    }
];

export default AccessGroupOssDeviceSearch;
